import { useEffect, useRef } from 'react';

// Follow the visible viewport, including the space left above a mobile keyboard.
export default function useTransferSheet(onClose, manageFocus = true) {
    const backdrop = useRef(null);
    const close = useRef(onClose);
    close.current = onClose;
    useEffect(() => {
        const root = backdrop.current;
        const viewport = window.visualViewport;
        const previous = document.activeElement;
        const overflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        let timer;
        const reveal = () => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                const active = document.activeElement;
                if (backdrop.current?.contains(active) && active?.matches('input,select,textarea')) active.scrollIntoView?.({ block: 'nearest', inline: 'nearest' });
            }, 80);
        };
        const update = () => {
            backdrop.current?.style.setProperty('--sheet-height', `${viewport?.height || window.innerHeight}px`);
            backdrop.current?.style.setProperty('--sheet-top', `${viewport?.offsetTop || 0}px`);
            reveal();
        };
        const keys = event => {
            const root = backdrop.current;
            if (!manageFocus) return;
            if (event.key === 'Escape') { event.preventDefault(); close.current?.(); }
            if (event.key !== 'Tab') return;
            const controls = [...(root?.querySelectorAll('button:not(:disabled),input:not(:disabled),select:not(:disabled),textarea:not(:disabled)') || [])].filter(el => el.getClientRects().length);
            const first = controls[0], last = controls[controls.length - 1];
            if (!first) return;
            if (event.shiftKey && (document.activeElement === first || !root.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
            else if (!event.shiftKey && (document.activeElement === last || !root.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
        };
        update();
        root?.querySelector('button[aria-label="닫기"]')?.focus({ preventScroll: true });
        viewport?.addEventListener('resize', update);
        viewport?.addEventListener('scroll', update);
        window.addEventListener('resize', update);
        window.addEventListener('focusin', reveal);
        window.addEventListener('keydown', keys);
        return () => {
            clearTimeout(timer);
            viewport?.removeEventListener('resize', update);
            viewport?.removeEventListener('scroll', update);
            window.removeEventListener('resize', update);
            window.removeEventListener('focusin', reveal);
            window.removeEventListener('keydown', keys);
            document.body.style.overflow = overflow;
            if (previous?.isConnected) previous.focus?.({ preventScroll: true });
        };
    }, [manageFocus]);
    return backdrop;
}
